export default {
  name: "PositionLevel",
  computed: {
    isLoading() {
      return this.$store.getters["positionLevel/getLoading"];
    },
    positionLevelData() {
      return this.$store.getters["positionLevel/getPositionLevelData"];
    },
    totalRecords() {
      return this.$store.getters["positionLevel/getTotalRecords"];
    }
  },
  data() {
    return {
      listTabMenu: {
        privilages: {
          create: true,
          read: true,
          update: true,
          delete: true
        }
      },
      body: {
        page: 1,
        limit: 10,
        search: "",
        order: ""
      },
      bodyAdd: {
        name: ""
      },
      bodyUpdate: {
        name: ""
      },
      viewDetailData: {},
      isAdd: true,
      modalTitle: "Add Position Level",
      columns: [
        {
          label: "No",
          field: "no",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "5%",
          sortable: false
        },
        {
          label: "Name",
          field: "name",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "75%"
        },
        {
          label: "ACTION",
          field: "action",
          thClass: "table-header no-wrap text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle",
          width: "20%"
        }
      ],
      searchTimeout: null
    };
  },
  mounted() {
    this.loadPositionLevelData();
    this.setMenuPermissions();
  },
  methods: {
    // Set menu permissions
    setMenuPermissions() {
      const listMenu = JSON.parse(localStorage.getItem('listMenu') || '[]');
      const currentPath = window.location.pathname;
      const menu = listMenu.find((menu) =>
        menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
      );
      this.listTabMenu = menu ? menu.children.find((item) => item.link === currentPath) || menu : {};
    },

    // Load data
    async loadPositionLevelData() {
      const params = { ...this.body };
      await this.$store.dispatch("positionLevel/getPositionLevelList", params);
    },

    // Search with debounce
    onSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      this.searchTimeout = setTimeout(() => {
        this.body.page = 1;
        this.loadPositionLevelData();
      }, 500);
    },

    // Clear search
    clearSearch() {
      this.body.search = "";
      this.body.page = 1;
      this.loadPositionLevelData();
    },

    // Actions
    addData() {
      this.isAdd = true;
      this.modalTitle = "Add Position Level";
      this.resetAddForm();
      this.$bvModal.show("modal-position-level");
    },

    async viewData(data) {
      this.isAdd = null; // View mode
      this.modalTitle = "View Position Level";
      
      try {
        const response = await this.$store.dispatch("positionLevel/getPositionLevelById", data.id);
        this.viewDetailData = response.data || response;
        this.$bvModal.show("modal-position-level");
      } catch (error) {
        console.error("Error fetching position level detail:", error);
        this.$swal("Error", "Detail position level belum berhasil dimuat", "error");
      }
    },

    async editData(data) {
      this.isAdd = false;
      this.modalTitle = "Edit Position Level";
      
      try {
        const response = await this.$store.dispatch("positionLevel/getPositionLevelById", data.id);
        const detailData = response.data || response;
        
        this.bodyUpdate = {
          id: detailData.id,
          name: detailData.name || ""
        };
        
        this.$bvModal.show("modal-position-level");
      } catch (error) {
        console.error("Error fetching position level detail:", error);
        this.$swal("Error", "Detail position level belum berhasil dimuat", "error");
      }
    },

    deleteData(data) {
      this.$swal({
        title: "Apakah Anda yakin?",
        text: `Apakah Anda yakin ingin menghapus position level "${data.name}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Batal"
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.$store.dispatch("positionLevel/deletePositionLevel", data.id);
            
            this.loadPositionLevelData();
            this.$swal("Terhapus", "Position level berhasil dihapus", "success");
          } catch (error) {
            console.error("Error deleting position level:", error);
            let errorMessage = "Error while deleting position level";
            
            if (error.response && error.response.data) {
              const errorData = error.response.data;
              if (errorData.message) {
                errorMessage = errorData.message;
              } else if (errorData.error) {
                errorMessage = errorData.error;
              }
            }
            
            this.$swal("Error", errorMessage, "error");
          }
        }
      });
    },

    resetAddForm() {
      this.bodyAdd = {
        name: ""
      };
      if (this.$validator) {
        this.$validator.reset();
      }
    },

    // Save methods
    saveAdd() {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return false;
        
        try {
          const payload = {
            name: this.bodyAdd.name
          };
          
          await this.$store.dispatch("positionLevel/createPositionLevel", payload);
          
          this.$swal({
            title: "Success",
            text: "Position level berhasil ditambahkan",
            icon: "success",
            confirmButtonText: "OK"
          }).then(() => {
            this.loadPositionLevelData();
            this.$bvModal.hide("modal-position-level");
            this.resetAddForm();
          });
        } catch (error) {
          console.error("Error adding position level:", error);
          let errorMessage = "Error while adding position level";
          
          if (error.response && error.response.data) {
            const errorData = error.response.data;
            if (errorData.httpCode === 400 && errorData.error) {
              errorMessage = errorData.error;
            } else if (errorData.message) {
              errorMessage = errorData.message;
            } else if (errorData.httpMessage) {
              errorMessage = errorData.httpMessage;
            }
          }
          
          this.$swal("Error", errorMessage, "error");
        }
      });
    },

    saveUpdate() {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return false;
        
        try {
          const payload = {
            name: this.bodyUpdate.name
          };
          
          await this.$store.dispatch("positionLevel/updatePositionLevel", {
            id: this.bodyUpdate.id,
            data: payload
          });
          
          this.$swal({
            title: "Success",
            text: "Position level berhasil diperbarui",
            icon: "success",
            confirmButtonText: "OK"
          }).then(() => {
            this.loadPositionLevelData();
            this.$bvModal.hide("modal-position-level");
          });
        } catch (error) {
          console.error("Error updating position level:", error);
          let errorMessage = "Error while updating position level";
          
          if (error.response && error.response.data) {
            const errorData = error.response.data;
            if (errorData.httpCode === 400 && errorData.error) {
              errorMessage = errorData.error;
            } else if (errorData.message) {
              errorMessage = errorData.message;
            } else if (errorData.httpMessage) {
              errorMessage = errorData.httpMessage;
            }
          }
          
          this.$swal("Error", errorMessage, "error");
        }
      });
    },

    // Pagination
    onPageChange(payload) {
      this.body.limit = payload.currentPerPage;
      this.body.page = payload.currentPage;
      this.loadPositionLevelData();
    }
  }
};
